const initNavbar = () => {
    const navbar = document.querySelector("nav.navbar")
    const navMenu = document.querySelector(".nav-menu")
    if (!navbar || !navMenu) return
    const navButton = navbar.querySelector(".nav-menu-button")
    navButton.addEventListener("click", () => {
        navbar.classList.toggle("open")
        navMenu.classList.toggle("open")
    })
}

export default initNavbar